import { TimestampRange as PBTimestampRange } from "gen/proto/timestamprange/models_pb"
import { TimestampRange } from "shared-ts/libs/dates/timestampRange"

import { data } from "./data"
import { TypedAccessor } from "./types"
import { TableCellWidth } from "../TableCell"
import { DataColumn } from "../useTable/types"

type TimestampRangeAccessorFn<T> = TypedAccessor<
  T,
  PBTimestampRange | undefined
>
interface TimestampRangeColumn<T>
  extends Omit<DataColumn<T>, "type" | "renderCell" | "width"> {
  width?: DataColumn<T>["width"]
  header?: string
}

export type TimestampRangeColumnHelper<T> = (
  accessorFn: TimestampRangeAccessorFn<T>,
  col: TimestampRangeColumn<T>
) => DataColumn<T>

export function timestampRange<T>(
  accessorFn: TimestampRangeAccessorFn<T>,
  col: TimestampRangeColumn<T>
): DataColumn<T> {
  const { width, ...restCol } = col
  return data({
    renderCell: (rowData) => {
      const value = accessorFn(rowData)
      if (value === undefined) return undefined
      return TimestampRange.humanize(value)
    },
    width: width ?? TableCellWidth.Medium,
    ...restCol,
  })
}
